
import React from "react";
import _ from "underscore";
import { Loader } from "../../atoms";

interface Props {
  getPage: (pageNumber: number) => Promise<unknown>;
  items: IPagerState<unknown>;
  className?: string;
  children?: React.ReactChild;
  getFirstPage?: boolean;
}

interface LocalState {
  loadingPage: boolean;
}

export default class PagerScroll extends React.Component<Props, LocalState> {
  private listNode: HTMLDivElement;

  public constructor(props: Props) {
    super(props);

    this.state = {
      loadingPage: false,
    };
  }

  public componentDidMount() {
    if (this.props.getFirstPage) {
      this.getPage(true);
    }
  }

  private getPage = async (firstPage?: boolean): Promise<boolean> => {
    if (!firstPage && this.props.items.nextIndex == null) {
      return;
    }

    const index = firstPage ? 1 : this.props.items.nextIndex;

    this.setState({ loadingPage: true });

    try {
      await this.props.getPage(index);
    }
    finally {
      this.setState({ loadingPage: false });
    }
  }

  public handleScroll = (e: React.SyntheticEvent<HTMLDivElement>) => {
    const ele = this.listNode;

    const scrollThreshold = 10; // 10px from the bottom, can be a prop in the future

    // When scroll position has almost reached the bottom, invoke getPage
    if (ele.scrollTop >= ele.scrollHeight - (ele.clientHeight + scrollThreshold)) {
      this.getPage();
    }
  }

  public render() {

    return (
      <div className={this.props.className} ref={x => this.listNode = x} onScroll={_.debounce(this.handleScroll, 300, false)}>
        {this.props.children}
        {this.props.items.status === "PENDING" && this.state.loadingPage && (
          <Loader />
        )}
      </div>
    );
  }
}
